import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import workboxService from './services/workboxService';
import syncService from './offline_items/syncService';

// PWA: set manifest by URL ?module= so install uses correct name/icons/start_url (works in dev and when Django injects)
const params = new URLSearchParams(window.location.search);
const moduleParam = params.get('module');
if (moduleParam) {
  const link = document.querySelector('link[rel="manifest"]');
  if (link) {
    const base = process.env.PUBLIC_URL || '';
    link.setAttribute('href', `${base}/manifest.json?module=${encodeURIComponent(moduleParam)}`);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    workboxService.register();
  });
}

syncService.initialize();

reportWebVitals();
